import { Fragment } from 'react'

import { Box, Stack } from '@mui/material'

import { GeoBlockingTemplate } from '../_legacy/GeoBlocking/types'
import { territories } from '../forms/GeoBlockingTemplateForm'
import { RegionChip } from '../inputs/common/RegionChip'
import { Column } from '../table/base'
import { GeoBlockingTemplatesMap } from './types'

export const GET_GEOBLOCKING_TEMPLATE_DGE_TABLE_COLUMNS = (
  templateLocationMap: GeoBlockingTemplatesMap
): Column<GeoBlockingTemplate>[] => [
  {
    type: 'text',
    label: 'ID',
    id: 'id',
    sortAttribute: 'id'
  },
  {
    type: 'text',
    label: 'Name',
    id: 'name',
    align: 'left',
    sortAttribute: 'name'
  },
  {
    type: 'component',
    label: 'Territories',
    id: 'isWhiteList',
    render: (isWhiteList, data) => {
      const currentTemplate = templateLocationMap[data.id]

      return (
        <Box>
          {Object.keys(currentTemplate).map((locationType) => (
            <Fragment key={locationType}>
              <Box
                color={(theme) =>
                  isWhiteList ? theme.palette.success.main : theme.palette.error.main
                }
              >
                {isWhiteList ? `Allowed ${locationType}:` : `Blocked ${locationType}:`}
              </Box>
              <Stack direction="row" gap={0.5} flexWrap="wrap" pb={2}>
                {currentTemplate[locationType].map((countryName) => {
                  const territory = territories.find((t) => t.name === countryName)
                  if (territory) {
                    return <RegionChip key={territory.iso2} region={territory} withFlag />
                  }
                  return null
                })}
              </Stack>
            </Fragment>
          ))}
        </Box>
      )
    }
  }
]
